import { GrowthBookProvider } from '@growthbook/growthbook-react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { PersistGate } from 'redux-persist/integration/react';

import { ErrorBoundary, Toast } from '@/containers';
import { Router } from '@/router';
import { growthbook } from '@/services';
import { persistor, StoreProvider } from '@/store';
import { theme } from '@/theme';

const AppWithTheme = () => {
  return (
    <ThemeProvider theme={theme} defaultMode="light">
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Toast />
        <div className="App">
          <PersistGate loading={null} persistor={persistor}>
            <Router />
          </PersistGate>
        </div>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export function App() {
  return (
    <ErrorBoundary>
      <CssBaseline />
      <GrowthBookProvider growthbook={growthbook}>
        <StoreProvider>
          <AppWithTheme />
        </StoreProvider>
      </GrowthBookProvider>
    </ErrorBoundary>
  );
}
